import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Leaf } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useAuth } from "@/context/AuthContext";
import { useLang } from "@/context/LangContext";
import { t } from "@/i18n";

export default function Login() {
  const { login } = useAuth();
  const { lang } = useLang();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await login(email, password);
      nav("/app");
    } catch (err) {
      toast.error(err?.response?.data?.detail || t(lang, "error"));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen grid md:grid-cols-2">
      <div className="hidden md:block relative">
        <img
          src="https://images.unsplash.com/photo-1579017308347-e53e0d2fc5e9"
          alt="Journal"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-primary/20" />
      </div>
      <div className="flex items-center justify-center p-8">
        <form onSubmit={submit} className="w-full max-w-md space-y-6" data-testid="login-form">
          <Link to="/" className="flex items-center gap-2">
            <div className="w-9 h-9 rounded-xl bg-primary text-primary-foreground flex items-center justify-center">
              <Leaf className="w-5 h-5" strokeWidth={1.5} />
            </div>
            <span className="font-heading text-lg font-semibold">{t(lang, "app_name")}</span>
          </Link>
          <div>
            <h1 className="font-heading text-3xl font-medium">{t(lang, "login")}</h1>
          </div>
          <div className="space-y-2">
            <Label>{t(lang, "email")}</Label>
            <Input
              data-testid="login-email"
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="p-4"
            />
          </div>
          <div className="space-y-2">
            <Label>{t(lang, "password")}</Label>
            <Input
              data-testid="login-password"
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="p-4"
            />
          </div>
          <Button data-testid="login-submit" type="submit" disabled={busy} className="w-full rounded-full">
            {t(lang, "login")}
          </Button>
          <div className="text-sm text-muted-foreground">
            {t(lang, "no_account")} <Link to="/register" className="text-primary underline" data-testid="link-register">{t(lang, "register")}</Link>
          </div>
        </form>
      </div>
    </div>
  );
}
